import MyProbationProgress from "@/components/checklist/my-probation-progress";
import Drawer from "expo-router/drawer";
import { ScrollView, RefreshControl } from "react-native";
import { trpc } from "@/trpc/react";
import { useCrew } from "@/context/CrewProvider";
import { DrawerToggleButton } from "@react-navigation/drawer";
import colors from '@/constants/Colors';

export default function MyProbationPage() {
  const { currentCrewMember } = useCrew();

  const { refetch, isLoading } = trpc.probationChecklist.list.useQuery({
    crew_id: currentCrewMember?.id!,
    show_completed: true, // Show ALL items including completed ones
  }, {
    enabled: !!currentCrewMember?.id,
  });

  return (
    <>
      <Drawer.Screen
        options={{
          drawerLabel: 'My Probation',
          title: 'My Probation',
          headerStyle: {
            backgroundColor: colors.primary,
          },
          headerTintColor: colors.accent,
          headerLeft: () => <DrawerToggleButton tintColor={colors.accent} />
        }}
      />
      <ScrollView
        className="flex-1 bg-background"
        refreshControl={
          <RefreshControl refreshing={isLoading} onRefresh={() => refetch()} />
        }
        contentContainerStyle={{
          padding: 16,
          paddingTop: 40,
          gap: 20,
        }}
      >
        <MyProbationProgress />
      </ScrollView>
    </>
  );
}

